import React, { useEffect, useState } from "react";
import "./RandomPlaylist.css";

// Playlist IDs from the GCC Worship YouTube channel
const DEFAULT_PLAYLISTS = [
  "PLlfpe0DDwzp065euqYHzQM7S1X222WsmZ", // Tamil Songs
  "PLlfpe0DDwzp2X5o3br_eDTp-rU_yFhGP2", // English Songs
  "PLlfpe0DDwzp2Lcv9lxQywvfim0HYTkGps", // Malayalam Songs
  "PLlfpe0DDwzp2sPVR-C3TnlANlB3FhqqwU", // Bible Melodies
  "PLlfpe0DDwzp0ldn0ZnLBal-M_S8GVZdP6", // Bible Songs Jukebox
  "PLlfpe0DDwzp02eZ49PyVNvcbMOfaQL_Wk", // Tamil Karaoke
  "PLlfpe0DDwzp1JzZ-ipAE45Hufyg_M0BNL", // English Karaoke
  "PLlfpe0DDwzp0cMyAwgrWhrXjk-AymbnGP", // Malayalam Karaoke
  "PLlfpe0DDwzp1jmVFvCvEbpY7LOgQOdMYv", // Bible Book Highlights - English
  "PLlfpe0DDwzp1lPf404tiN5cGQnv_RPwaQ", // Kids Bible Books Highlights
  "PLlfpe0DDwzp3Rk9X-AWDNF9nbvYYnqsoY", // Romans English Bible Message
  "PLlfpe0DDwzp1V1_PA3yB04A-AHAJ55hfn", // Tamil Bible Message
  "PLlfpe0DDwzp2JTpFvINtyMI1307E83Wa1", // Bible Chapter Summary in 3 Minutes - English
  "PLlfpe0DDwzp3wxJwEfF6bnH8m2VReVs-y", // Kids Bible Chapter Highlights
  "PLlfpe0DDwzp0qyYeMRgfawc-JSarbF05P", // Holy Reels
  "PLlfpe0DDwzp1B7MLw39wOhpBcZzkbum4U", // Spiritual Guidance & Bible Stories
  "PLlfpe0DDwzp0JVlMGCrz1GILAWjl-TQjI", // Prayers & Spiritual Wisdom
  "PLlfpe0DDwzp1-FZLlJ8pt4IOM87D8fBdC", // Malayalam Bible Message
];

/**
 * Component to display a random GCC Worship playlist.
 * Accepts an array of playlist IDs and optionally a title message.
 */
export default function RandomPlaylist({ playlistIds = DEFAULT_PLAYLISTS, heading = "More from GCC Worship" }) {
  const [embedUrl, setEmbedUrl] = useState(null);

  useEffect(() => {
    if (!playlistIds.length) return;
    const randomIndex = Math.floor(Math.random() * playlistIds.length);
    const playlistId = playlistIds[randomIndex];
    // Random start index to attempt random video start
    const startIndex = Math.floor(Math.random() * 50) + 1;
    setEmbedUrl(
      `https://www.youtube.com/embed/videoseries?list=${playlistId}&index=${startIndex}&autoplay=1&mute=1`
    );
  }, [playlistIds]);

  if (!embedUrl) return null;

  return (
    <div className="random-playlist">
      <h2>{heading}</h2>
      <p>
        Enjoy this playlist and explore more worship videos on our YouTube channel.
      </p>
      <iframe
        src={embedUrl}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title="GCC Worship Playlist"
      ></iframe>
    </div>
  );
}
